export var PortfolioCreationSelectedTabEnum;
(function (PortfolioCreationSelectedTabEnum) {
    PortfolioCreationSelectedTabEnum[PortfolioCreationSelectedTabEnum["rulesBased"] = 0] = "rulesBased";
    PortfolioCreationSelectedTabEnum[PortfolioCreationSelectedTabEnum["rulesBasedOnFunds"] = 1] = "rulesBasedOnFunds";
    PortfolioCreationSelectedTabEnum[PortfolioCreationSelectedTabEnum["manualComposition"] = 2] = "manualComposition";
})(PortfolioCreationSelectedTabEnum || (PortfolioCreationSelectedTabEnum = {}));
